// extracted by mini-css-extract-plugin
export var modal = "_ls-0";